import { render, staticRenderFns } from "./AppStoreLinks.vue?vue&type=template&id=0ff40aef&scoped=true&"
import script from "./AppStoreLinks.vue?vue&type=script&lang=js&"
export * from "./AppStoreLinks.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreLinks.vue?vue&type=style&index=0&id=0ff40aef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff40aef",
  null
  
)

export default component.exports